import { Observable } from 'rxjs';

export const DEFAULT_ACCEPTED_EXTENSIONS: string[] = [
    '.jpg', '.jpeg', '.png', '.pdf', '.heic',
    '.xls', '.xlsx', '.doc', '.docx', '.txt', '.csv', '.mp4'
];
export const DEFAULT_MIN_FILE_SIZE_BYTES = 1024;
export const DEFAULT_MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export const DEFAULT_MAX_TOTAL_SIZE_BYTES = 250 * 1024 * 1024;

export type UploadEntry = {
    file: File;
    status: 'uploading' | 'uploaded' | 'error' | 'deleting';
    fileId?: number;
    fileName?: string;
    url?: string;
    uploadError?: string;
    deleteError?: string;
};

/** Narrow shape of a single file in the POST /v1/espp/files response. */
export type UploadedFileResponse = {
    id: number;
    name: string;
    url: string;
};

/** File metadata the dialog already knows client-side; returned via afterClosed() in auto-upload mode. */
export type SubmittedFile = {
    id: number;
    name: string;
    size: number;
    url: string;
    category: string;
};

export type FileUploadDialogConfig = {
    acceptedExtensions?: string[];
    minFileSizeBytes?: number;
    maxFileSizeBytes?: number;
    maxTotalSizeBytes?: number;
    /** Bytes already committed (e.g. from prior dialog sessions) for cumulative size enforcement. */
    existingTotalBytes?: number;
    /** Files already attached (used alongside maxFiles to enforce a total count across sessions). */
    existingFileCount?: number;
    /** Maximum total number of files allowed (existing + new). No limit when omitted. */
    maxFiles?: number;
    /**
     * When provided the dialog uploads each file individually by calling this function.
     * On success the dialog closes with no return value.
     * When omitted the dialog closes with File[] and the caller handles upload.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    uploadFn?: (file: File) => Observable<any>;
    title?: string;
    description?: string;
    /** Optional note rendered below the accepted file types list. */
    footerNote?: string;
    /**
     * Auto-upload mode (Claims / Enrollments).
     * When all three are set the dialog uploads to POST /v1/espp/files immediately
     * after selection and submits via POST /v1/espp/{fileableType}/{fileableId}/submit.
     */
    domain?: string;
    fileableType?: string;
    fileableId?: number;
};
